import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-travel-bill-reject',
  templateUrl: './travel-bill-reject.component.html',
  styleUrls: ['./travel-bill-reject.component.css']
})
export class TravelBillRejectComponent implements OnInit {
    travelBillNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.travelBillNo = this.stateService.getStateParams()['travelbill_no'];
    }

    private async loadEdit() {
        if (!!this.travelBillNo) {
            this.edit = (await this.datatask.Post(1327, { travelbill_no: this.travelBillNo }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1326, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back('2');
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    travelbill_reject_messagetext: string;
    travelbill_no: string;
}
